// You can customize the template with the help of this file

import {ToastPosition} from 'react-hot-toast'
interface ThemeConfig {
  app: {
    appLogoImage: unknown
    appName: string
  }
  layout: {
    contentWidth: 'boxed' | 'full'
    customizer: boolean
    footer: {
      type: 'static' | 'sticky' | 'hidden'
    }
    isRTL: boolean
    menu: {
      isCollapsed: boolean
      isHidden: boolean
    }
    navbar: {
      backgroundColor: 'white' | 'primary' | 'secondary' | 'success' | 'danger' | 'info' | 'warning' | 'dark'
      type: 'static' | 'sticky' | 'floating' | 'hidden'
    }
    scrollTop: boolean
    skin: 'light' | 'dark' | 'bordered' | 'semi-dark'
    toastPosition: ToastPosition
    type: 'vertical' | 'horizontal'
  }
}

import logoPagaleve from '@src/assets/images/logo-rebranding.svg'
//Template config options
const themeConfig: ThemeConfig = {
  app: {
    appLogoImage: logoPagaleve,
    appName: 'Pagaleve'
  },
  layout: {
    // vertical, horizontal
    contentWidth: 'boxed',
    customizer: false,
    footer: {
      type: 'static' // static, sticky, hidden
    },
    isRTL: false,
    // full, boxed
    menu: {
      isCollapsed: false,
      isHidden: false
    },
    navbar: {
      // static , sticky , floating, hidden
      backgroundColor: 'white',
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating' // BS color options [primary, success, etc]
    },
    scrollTop: true,
    skin: 'light',
    // Enable scroll to top button
    toastPosition: 'top-right',
    // light, dark, bordered, semi-dark
    type: 'vertical' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
